import React from 'react'
import { MessageBox } from 'components/atoms/MessageBox'

/** @type {import('./types').ProhibitedArea} */
const ProhibitedArea = () => (
    <MessageBox negative floating size='big' header='Permission Denied'>
        <p>You don't have permisson to enter in this area.</p>
    </MessageBox>
)

export default ProhibitedArea;
